/**
 * SSFType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file SSFType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum SSFType {
  BATTLE_CRY_1 = 0,
  BATTLE_CRY_2 = 1,
  BATTLE_CRY_3 = 2,
  BATTLE_CRY_4 = 3,
  BATTLE_CRY_5 = 4,
  BATTLE_CRY_6 = 5,
  SELECT_1 = 6,
  SELECT_2 = 7,
  SELECT_3 = 8,
  ATTACK_1 = 9,
  ATTACK_2 = 10,
  ATTACK_3 = 11,
  PAIN_1 = 12,
  PAIN_2 = 13,
  LOW_HEALTH = 14,
  DEAD = 15,
  CRITICAL_HIT = 16,
  TARGET_IMMUNE = 17,
  LAY_MINE = 18,
  DISARM_MINE = 19,
  STEALTH = 20,
  SEARCH = 21,
  UNLOCK = 22,
  UNLOCK_FAIL = 23,
  UNLOCK_SUCCESS = 24,
  SOLO_MODE = 25,
  PARTY_MODE = 26,
  POISONED = 27,
}